<!--
 * @Author: 邓诗敏
 * @Date: 2021/11/25 15:22
 * @Description: 记账成功弹窗
-->
<template>
  <el-dialog
    title="温馨提示"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
  >
    <div class="content">
      <img src="@/assets/record/jzcg.png" alt="" />
      <div style="margin-top:17px;font-size:18px;color:#666">记账成功!</div>
      <div style="margin-top:10px;font-size:15px;color:#969696">随时查看,方便快捷</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="know" @click="dialogVisible = false">知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AccountSuccess",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    visible(v) {
      this.dialogVisible = v
    },
    dialogVisible(v) {
      this.$emit("update:visible", v)
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
/deep/.el-dialog__title {
  color: #000;
  font-size: 18px;
}
/deep/.el-dialog__footer {
  text-align: center;
  padding: 0px 0px 20px 0px!important;
}
/deep/.el-button.know {
  background: #b79255;
  color: #fff !important;
  border:#b79255 ;
  height: 34px;
  padding: 0px 15px;
  &:hover{
  background: #b79255;
  border:#b79255 ;
  color: #fff !important;
  }
}
.content{
    text-align: center;
    padding: 30px 0;
}
</style>

